import { _GlobeView } from "@deck.gl/core";
import { BitmapLayer } from "@deck.gl/layers";

export const GLOBE_VIEW_ID = 'globe';

export const INITIAL_VIEW_STATE = {
  [GLOBE_VIEW_ID]: {

    latitude: 10.65,
    longitude: 73.65,
    zoom: 2,
    pitch: 0,
    bearing: 0,
  }
};

export function createLayers(layerConfigs: Array<{
  imageIndex: number;
  bitmapImages: (string | HTMLImageElement)[];
  show: boolean;
  transparency: number;
}>) {
  return layerConfigs
    .filter(config => config.show)
    .map((config, index) => {
      const image = config.bitmapImages[config.imageIndex];
      if (!image) {
        return null;
      }
      
      return new BitmapLayer({
        id: `bitmap-layer-${index}`,
        image,
        bounds: [-180, -85, 180, 85],
        opacity: config.transparency,
      });
    })
    .filter(layer => layer !== null);
}

export const globeView = new _GlobeView({
  id: GLOBE_VIEW_ID,
  resolution: 10
}); 